import { RouteInterface, RoutesInterface } from '../../types/routes';

const worldTrackerRoute: RouteInterface = {
  id: 'world_tracker',
  label: 'Countdown to 2030',
  path: '/world-tracker',
  icon: 'fa-globe',
  tooltip: 'World Tracker - Countdown to 2030',
}

export const worldTrackerRoutes: RoutesInterface = {
  WORLD_TRACKER: worldTrackerRoute,
}
